// Site layout — title + tabs persist across overview / floors / etc.

import { createFileRoute } from "@tanstack/react-router";

import { SiteLayout } from "../features/sites/SiteLayout";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug",
)({
  component: SiteLayoutRoute,
});

function SiteLayoutRoute() {
  const { accountSlug, tenantSlug, siteSlug } = Route.useParams();
  return (
    <SiteLayout
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
    />
  );
}
